export enum PRODUCT_LIST_FIELD {
  BARCODE = 'barcode',
  LABORATORY = 'laboratory',
  QUANTITY = 'quantity',
  IN_STOCK = 'inStock',
  CUT_OFF_TIME = 'corteTime',
  DELIVERY_TIME = 'deliveryTime',
  INVOICE_AMOUNT = 'invoiceAmount',
  PAYMENT_DUE_DATE = 'paymentDueDate',
  OFFER_CODE = 'oferta',
  DISCOUNT = 'discount',
  FACTORY_PRICE = 'factoryPrice',
  TAXES = 'taxes',
  ST = 'st',
  PMC = 'pmc',
  CATEGORY = 'categoria',
  COMPANY = 'empresa',
}

export type ProductListColumnConfig = {
  field: PRODUCT_LIST_FIELD;
  label: string;
  enabled: boolean;
};

export const productListDefaultColumns: ProductListColumnConfig[] = [
  {
    field: PRODUCT_LIST_FIELD.BARCODE,
    label: 'EAN',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.LABORATORY,
    label: 'LABORATÓRIO',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.QUANTITY,
    label: 'QTDE',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.IN_STOCK,
    label: 'ESTOQUE',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.CUT_OFF_TIME,
    label: 'CORTE',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.DELIVERY_TIME,
    label: 'ENTREGA',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.INVOICE_AMOUNT,
    label: '($) NF',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.PAYMENT_DUE_DATE,
    label: 'PRAZO',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.OFFER_CODE,
    label: 'OFERTA',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.DISCOUNT,
    label: 'DESC',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.FACTORY_PRICE,
    label: '($) FÁBRICA',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.TAXES,
    label: 'REP. FISCAL',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.ST,
    label: 'ST',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.PMC,
    label: 'PMC',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.CATEGORY,
    label: 'CATEGORIA',
    enabled: true,
  },
  {
    field: PRODUCT_LIST_FIELD.COMPANY,
    label: 'EMPRESA',
    enabled: true,
  },
];
